'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyPurchaseMotionEligibility = undefined;

var _getPurchaseMotionData = require('self-service-api/api/getPurchaseMotionData');

var _productProperties = require('ui-addon-upgrades/_core/common/constants/productProperties');

var _productProperties2 = _interopRequireDefault(_productProperties);

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _upgradeProducts = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts');

var _PurchaseMotionTypes = require('ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes');

var PurchaseMotionTypes = _interopRequireWildcard(_PurchaseMotionTypes);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROPERTY_KEY = 'purchaseMotionEligibility';

var getPropertyPurchaseMotionEligibility = exports.getPropertyPurchaseMotionEligibility = function getPropertyPurchaseMotionEligibility() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      upgradeProduct = _ref.upgradeProduct;

  var productProperty = _productProperties2.default[upgradeProduct];

  if (!productProperty) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, []);
  }

  var merchandiseId = _productProperties2.default[upgradeProduct].merchandiseId;


  if (!merchandiseId) {
    // An upgradeProduct will not have an associated merchandiseId if
    // it is a concept that we've created rather than an actual SKU. I.e. GENERAL
    return (0, _createProperty.createProperty)(PROPERTY_KEY, [PurchaseMotionTypes.TALK_TO_SALES]);
  }

  var merchandiseIdToUse = merchandiseId;

  //Enterprise upgrade product can be used when a feature can be unlocked by any enterprise SKU
  // Use Marketing Enterprise as a proxy for purchase motion eligibility of enterprise level SKUs
  if (upgradeProduct === _upgradeProducts.upgradeProducts.ENTERPRISE) {
    merchandiseIdToUse = _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE;
  }

  return (0, _getPurchaseMotionData.getPurchaseMotionData)([merchandiseIdToUse]).then(function (purchaseMotionData) {
    var purchaseMotionEligibility = purchaseMotionData.purchaseMotions[merchandiseIdToUse] || [];
    var propertyValue = purchaseMotionEligibility.map(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          key = _ref2.key;

      return key;
    });

    return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
  }).catch(function () {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, []);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertyPurchaseMotionEligibility.js
// module id = 472
// module chunks = 3 4 5